import { Expose, Transform } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { PatientSummaryQueryDto } from '../patient-summary-query.dto';
import { TransformPropertiesToClass } from '../dto.util';

export class TeledermatologicalReferralSearchQueryResult {
  @Expose()
  @IsUUID()
  @IsNotEmpty()
  referral_id: string;

  @Expose()
  @IsNotEmpty()
  referral_id_number: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  referral_medical_unit_name: string;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_assessment_medical_unit_name?: string;

  @Expose()
  @IsDate()
  @IsNotEmpty()
  created_date: Date;

  @Expose()
  @IsUUID()
  @IsNotEmpty()
  lesion_id: string;

  @Expose()
  @IsUUID()
  @IsNotEmpty()
  condition_type_id: string;

  @Expose()
  @TransformPropertiesToClass('patient_', PatientSummaryQueryDto)
  @ValidateNested()
  patient: PatientSummaryQueryDto;

  @Expose()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  undiagnosable: boolean;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_diagnosis_id?: string;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_diagnosis_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_diagnosis_name_da?: string;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_diagnosis_name_de?: string;

  @Expose()
  @IsString()
  @IsOptional()
  clinical_diagnosis_id?: string;

  @Expose()
  @IsString()
  @IsOptional()
  clinical_diagnosis_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  clinical_diagnosis_name_da?: string;

  @Expose()
  @IsString()
  @IsOptional()
  clinical_diagnosis_name_de?: string;

  @Expose()
  @IsString()
  @IsOptional()
  referrer_first_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  referrer_last_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_assessment_user_first_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  teledermatological_assessment_user_last_name?: string;

  @Expose()
  @IsBoolean()
  released_to_allowed_specialist_group_members: boolean;

  @Expose()
  @IsOptional()
  @IsDate()
  @IsNotEmpty()
  released_to_allowed_specialist_group_members_date?: Date;

  @Expose()
  @IsOptional()
  @IsBoolean()
  condition_is_marked_by_user?: boolean;
}
